<template>
  <div>
    <div class="bannerStyle">
      <img src="@/assets/enterprisea.jpg" />
      <img src="@/assets/enterpriseb.jpg" />
      <img src="@/assets/enterprisec.jpg" />
    </div>
    <div class="enter" v-if="title == ''">
      <p class="p"><el-link href="/" :underline="false">首页</el-link> / 心理知识</p>
      <div>
        <dl class="mental" v-for="(item,index) in list" :key="index" @click="hrefDetail(item)">
          <dd class="floatLeft">
            <b>{{item.title}}</b>
            <p>{{item.label}}</p>
            <a href="javascript:;">MORE>>></a>
          </dd>
          <dt class="floatRight">
            <img :src="item.img" />
          </dt>
        </dl>
      </div>
    </div>
    <mentalDetail v-else @updateParentValue="handleUpdate" :titles="title"></mentalDetail>
  </div>
</template>
<script>
  import mentalDetail from './mentalDetail.vue';
  export default {
    components: {
      mentalDetail
    },
    data() {
      return {
        list: [{
            title: 'PTSD&ASD的基础知识、治疗以及创伤后成长',
            label: '在我们所生活的世界中，个体可能会遭遇各种形式的创伤或极端应激事件，从自然灾害到人为的暴力行为，从突如其来的失落到战争与冲突(Smith,2019)。这些事件所留下的影响，尤其在心理和',
            img: require('@/assets/xl1.jpg')
          },
          {
            title: '关于抑郁症的科普',
            label: '重性抑郁障碍(Major Depressive Disorder，MDD)是一种精神疾病，表现为持续的悲伤、失望和兴趣缺失，并伴有其他症状，如失眠、食欲改变、注意力不集中和疲劳。MDD是一种严重的疾病',
            img: require('@/assets/xl2.jpg')
          },
          {
            title: '失眠:深入理解及其缓解之道',
            label: '失眠，一个大家耳熟能详的词汇，但是你真正了解它吗?失眠，或称为睡眠障碍，是指在合适的睡眠环境和条件下，个体出现入睡困难、维持睡眠的能力减退或早醒等导致睡眠时间或睡眠质量不足',
            img: require('@/assets/xl3.jpg')
          },
          {
            title: '复原力',
            label: '复原力”(Resilience)是一个心理学术语，用于描述个体在面对压力、困难、挫折或其他形式的逆境时，能够迅速恢复到原先的正常状态(或者接近正常状态)的能力。这一概念在心理健康、领导',
            img: require('@/assets/xl4.jpg')
          },
          {
            title: '心中的拉锯战:理解认知解离的根源',
            label: '在繁华的都市背后，每个人的心灵深处都可能藏有一个小小的秘密一- 那些内心 与行为之间的不协调瞬间。你是否曾经觉得自己做出了与内心信仰相违背的事情? 或者，你是否曾试图避免某种情感',
            img: require('@/assets/xl5.jpg')
          }
        ],
        title: ""
      }
    },
    created() {
      const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
      if (currentPosition > 0) {
        // 如果当前位置不为零，则执行滚动操作
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
      var userText = JSON.parse(localStorage.getItem('userText'));
      if (userText != undefined) {
        this.title = userText;
      }
    },
    methods: {
      hrefDetail(item) {
        this.title = item.title;
      },
      handleUpdate(newValue) {
        this.title = "";
      }
    },
  }
</script>
<style scoped>
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }

  .enterImg {
    margin-top: 50px;
  }

  .enterImg img {
    width: 100%;
    display: block;
  }

  .enter {
    width: 950px;
    margin: auto;
    display: table;
  }

  .enter .p {
    font-size: 14px;
    padding: 30px 0;
  }

  .enter .p a {
    font-size: 14px;
  }

  .mental {
    margin-bottom: 50px;
    display: table;
    cursor: pointer;
    width: 100%;
  }

  .mental .floatLeft {
    width: 534px;
  }

  .mental .floatLeft b {
    font-size: 16px;
    color: #707070;
  }

  .mental .floatLeft p {
    line-height: 24px;
    color: #707070;
    margin: 12px 0 20px 0;
    font-size: 14px;
  }

  .mental .floatLeft a {
    color: #707070;
    font-size: 14px;
  }

  .mental .floatRight {
    width: 315px;
  }

  .mental .floatRight img {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/mentalKnowledge.vue